export const parseChatStreamResponse = (responseString: string) => {
  if (responseString?.startsWith("data:")) {
    return JSON.parse(responseString?.slice(5));
  } else {
    return responseString;
  }
};

interface Citation {
  index: any;
  source: string;
  pages: number[];
  type: string;
  domain: string;
}

export const createCitations = (sourceFiles: any): Citation[] => {
  const citations: Citation[] = [];

  if (!sourceFiles) return citations;

  if (JSON.stringify(sourceFiles).includes("cited")) {
    sourceFiles.forEach((sourceObj: any) => {
      const key = Object.keys(sourceObj)[0];
      const sourceInfo = sourceObj[key];

      if (sourceInfo && sourceInfo.source) {
        citations.push({
          index: key,
          source: sourceInfo.source,
          pages: sourceInfo.pages || [],
          type: sourceInfo.type || "internal",
          domain: sourceInfo.domain,
        });
      }
    });
  } else {
    sourceFiles?.forEach((sourceFile: any, index: number) => {
      const source = Object.keys(sourceFile)[0];
      citations.push({
        index: index.toString(),
        source,
        pages: Object.values(sourceFile),
        type: "internal",
        domain: "",
      });
    });
  }

  return citations;
};

export const parseSources = (source: string, domain = "") => {
  if (source?.startsWith("gs:")) {
    return source?.split("/")?.pop();
  } else if (domain) {
    return `${domain}`;
  } else if (source?.startsWith("http")) {
    return `${source?.split("/")?.at(2)}/${source?.split("/")?.at(3)}`;
  }
  return source;
};

export const getFileTypeFromGCSPath = (gcsPath: string) => {
  const match = gcsPath.match(/\.([^.]+)$/);

  if (match && match[1]) {
    return match[1].toLowerCase();
  }

  return null;
};

export function convertToMarkdown(input: string): string {
  try {
    if (!input || typeof input !== "string") {
      return "";
    }

    let cleanedInput = input.replace(/\\n/g, "\n");

    const rows = cleanedInput
      .split("\n")
      .filter((row) => row.trim().startsWith("|"));

    if (rows.length < 2) {
      return "";
    }

    const processedRows = rows.map((row) => {
      const cells = row.split("|");
      return cells.map((cell) => cell.trim()).join("|");
    });

    return processedRows.join("\n");
  } catch (error) {
    return "";
  }
}

export const mapBackendSectionToDisplayName = (name: string) => {
  if (name === "Feature needs with Rationale")
    return "Feature Needs with Rationale";
  return "";
};

export const mapDisplayNameToBackendSection = (name: string) => {
  if (name === "Feature Needs with Rationale")
    return "Feature needs with Rationale";
  return "";
};

export function generateUUID(): string {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
